/**
 *********************************
 * Emotions Rating - Yanci Nerio *
 *********************************
 * Emotions Rating
 * Version: 2.0.1
 * URL: https://github.com/YanNerio/emotion-ratings
 * Description: This plugin allows you to create ratings using emojis
 * Requires: >= 1.9
 * Author: Yanci Nerio (www.yancinerio.com)
 * License: MIT
 */
import $ from 'jquery';

import emogjiDissatisfiedVery from '../../../assets/dortmunder-emojis/Smileys_RZ-01.png';
import emogjiDissatisfied from '../../../assets/dortmunder-emojis/Smileys_RZ-02.png';
import emogjiNeutral from '../../../assets/dortmunder-emojis/Smileys_RZ-03.png';
import emogjiSatisfied from '../../../assets/dortmunder-emojis/Smileys_RZ-04.png';
import emogjiSatisfiedVery from '../../../assets/dortmunder-emojis/Smileys_RZ-05.png';

(function ($, document, window, undefined) {
  'use strict';

  let pluginName = 'dortmunderemotionsratings';
  let $element;

  let defaults = {
    bgEmotion: emogjiNeutral,
    count: 5,
    color: '#d0a658;',
    emotionSize: 30,
    inputName: 'ratings[]',
    emotionOnUpdate: null,
    ratingCode: 5,
    disabled: false,
    useCustomEmotions: false,
    transformImages: false,
    onUpdate: function (value) {},
  };

  let emotionsArray = [
    emogjiDissatisfiedVery,
    emogjiDissatisfied,
    emogjiNeutral,
    emogjiSatisfied,
    emogjiSatisfiedVery,
  ];

  class Plugin {
    constructor(element, options) {
      this.element = element;

      this.settings = $.extend({}, defaults, options);
      this.useCustomEmotions = false;

      this.$el = $(element);
      this.$el.data(name, this);

      this._defaults = defaults;
      this._name = pluginName;

      let meta = this.$el.data(name + '-opts');
      this.opts = $.extend(this._defaults, options, meta);

      this.containerCode = this.$el.attr('id');
      this.elementContainer = $(element);
      this.styleCode = 'emotion-style-' + this.containerCode;
      this.containerCode = 'emotion-container-' + this.containerCode;
      this.code = 'emoji-rating-' + this.containerCode;

      this.clicked = [];
      this.clicked[this.containerCode] = false;

      this.init();
    }

    init() {
      $element = $(this.element);
      this.count = 0;
      this.manageClick();
      this.emotionStyle();
      this.emotionTitleStyle();
      this.renderEmotion();
      this.manageHover();
    }

    emotionTitleStyle() {
      const titleStyle = `
      [data-tooltip] {
        position: relative;
      }

      [data-tooltip]:after {
        content: attr(data-tooltip);
        position: absolute;
        left: 50%;
        bottom: 100%; /* put it on the top */
        background-color: white;
        padding: 5px 10px;
        border: solid 1px;
        border-color: black;
        width: max-content;
        opacity: 0;
        -webkit-transition: opacity 0.2s;
      font-size: 1em;
      }

      [data-tooltip]:hover:after {
        opacity: 1;
      }

      div[data-tooltip]:after {
        left: 5px!important;
      }

      /* the right-most emojis' tooltips would extend past the viewport edge
         and force a horizontal scrollbar on mobile. flip the last two so they
         grow leftwards (right-anchored) and stay on screen. */
      div[data-tooltip]:nth-last-child(-n + 2):after {
        left: auto!important;
        right: 5px;
      }`;
      $element.append('<style>' + titleStyle + '</style>');
    }

    emotionStyle() {
      let styles =
        '.' +
        this.styleCode +
        '{margin-right: -5px;border-radius: 50%;cursor:pointer;opacity:0.6;display: inline-block;font-size:' +
        this.settings.emotionSize +
        'px; text-decoration:none;line-height:0.9;text-align: center;color:' +
        this.settings.color +
        '}';
      $element.append('<style>' + styles + '</style>');
    }

    renderEmotion() {
      let container =
        "<div id='dortmunder-emojis-container' style='display:flex;' class='" +
        this.containerCode +
        "'>";
      let emotionDiv;
      let questionCount = this.settings.question.choices.length;

      for (let i = questionCount; i >= 1; i -= 1) {
        emotionDiv =
          "<div><img id='dortmunder-emojis-img' src='" +
          emotionsArray[questionCount - i] +
          "' class='" +
          this.styleCode +
          "' data-index='" +
          i +
          "'></div>";
        container += emotionDiv;
      }

      container += '</div>';
      $element.append(container);
      if (this.settings.initialRating > 0) {
        this.updateInput(this.settings.initialRating);
        const invertRating = [0, 5, 4, 3, 2, 1];
        this.initalRate(invertRating[this.settings.initialRating]);
      }
    }

    clearEmotion() {
      let self = this;
      if (!this.settings.disabled) {
        self.elementContainer.find('.' + this.styleCode + '').each(function () {
          $(this).css('opacity', 0.6);
        });
      }
    }

    showEmotion(count) {
      let self = this;
      let emotion = getEmotion(this.settings.emotions, count, false);
      let position = count - 1;
      this.clearEmotion();

      self.elementContainer.find('.' + this.styleCode + '').css('opacity', 0.3);
      self.elementContainer
        .find('.' + this.styleCode + '')
        .eq(position)
        .css('opacity', 1);
      self.elementContainer
        .find('.' + this.styleCode + '')
        .eq(position)
        .html(emotion);
      self.elementContainer
        .find('.' + this.styleCode + '')
        .eq(position)
        .parent()
        .attr(
          'data-tooltip',
          `${this.settings.question.choices[position]?.text}`,
        );
    }

    manageHover() {
      let self = this;
      if (!self.settings.disabled) {
        this.elementContainer.on(
          {
            mouseenter: function () {
              let count = parseInt($(this).data('index'), 10);
              let questionCount = self.settings.question.choices.length;
              self.showEmotion(questionCount - count + 1);
            },
            mouseleave: function () {
              self.clearEmotion();
              let selectedItem = self.elementContainer.find('#selectedItem');

              let index = selectedItem[0]?.value
                ? parseInt(selectedItem[0].value, 10)
                : '';
              if (index != '') {
                let questionCount = self.settings.question.choices.length;
                self.showEmotion(questionCount - index + 1);
              }
            },
          },
          '.' + this.styleCode + '',
        );
      }
    }

    manageClick() {
      let self = this;
      if (!self.settings.disabled) {
        self.elementContainer.on(
          'click',
          '.' + self.styleCode + '',
          function () {
            let index = $(this).data('index');
            let count = parseInt(index, 10);
            self.count = count;
            self.updateInput(count);
            self.settings.onUpdate.call(self, count);
            let questionCount = self.settings.question.choices.length;
            self.showEmotion(questionCount - count + 1);
          },
        );
      }
    }

    initalRate(count) {
      let self = this;
      self.showEmotion(count);
    }

    updateInput(count) {
      let self = this;
      let _input = self.elementContainer.find('#selectedItem');
      _input.val(count);
    }
  }

  $.extend();

  $.fn[pluginName] = function (options) {
    return this.each(function () {
      if (!$.data(this, 'plugin_' + pluginName)) {
        $.data(this, 'plugin_' + pluginName, new Plugin(this, options));
      }
    });
  };

  let getEmotion = function (_emotions, count, onlyIndex = false) {
    let emotion;
    let emotionsLength = _emotions.length;
    if (emotionsLength == 1) {
      emotion = onlyIndex ? 0 : emotionsArray[_emotions[0]];
    } else {
      let emotionIndex = count - 1;
      emotion = onlyIndex
        ? emotionIndex > emotionsLength - 1
          ? emotionsLength - 1
          : emotionIndex
        : emotionsArray[_emotions[count - 1]];
    }
    return emotion;
  };
})($, document, window);
